import angular from 'angular'
import { RegisterManager } from '../../managers/register-manager'

/**
 * Directive for a single currency symbol based on the current outlet.
 *
 * @module webregister.directives.wrCurrencySymbol
 */
angular
  .module('webregister.directives')
  .directive('wrCurrencySymbol', function () {
    return {
      restrict: 'E',
      template: '{{currencySymbolCtrl.currencySymbol}}',
      controllerAs: 'currencySymbolCtrl',
      /**
       * =======================================
       * INFO FIELD CONTROLLER
       * =======================================
       */
      controller(this: $TSFixMe, $scope, registerManager: RegisterManager) {
        /**
         * Set the currency symbol for the current outlet.
         *
         * @method setCurrencySymbol
         */
        this.setCurrencySymbol = function () {
          const outlet = registerManager.getActiveOutlet()

          this.currencySymbol = outlet ? outlet.currency_symbol : '$'
        }

        this._onActiveOutletChange = function () {
          $scope.$applyAsync(() => this.setCurrencySymbol())
        }

        registerManager.on(
          'activeOutletChange',
          this._onActiveOutletChange,
          this
        )
        $scope.$on('$destroy', () =>
          registerManager.off('activeOutletChange', this._onActiveOutletChange)
        )

        this.setCurrencySymbol()
      },
    }
  })
